import type { KpiSection } from 'src/utils/gql/types';

type ResolveKpiSectionToUpdateArgs = {
  selectedSection: KpiSection | null;
  lastKnownSectionId: string | null;
  sections: KpiSection[];
};

/**
 * Risolve in modo deterministico quale sezione KPI aggiornare.
 *
 * Per UX: se l'utente ha già una sezione selezionata, quella vince sempre.
 * Altrimenti proviamo a recuperare l'ultima sezione usata (persistita) dalla lista.
 */
export function resolveKpiSectionToUpdate({
  selectedSection,
  lastKnownSectionId,
  sections,
}: ResolveKpiSectionToUpdateArgs): KpiSection | null {
  if (selectedSection) return selectedSection;
  if (!lastKnownSectionId) return null;
  return sections.find((s) => s.id === lastKnownSectionId) ?? null;
}
